import { AnimatedGroup } from "@/components/ui/animated-group";
import { Card } from "@/components/ui/card";
import { cn } from "@/lib/utils";

/**
 * BentoGrid Component
 * Renders a responsive grid of cards with customizable variants
 *
 * @param {Object[]} items - Array of items to display
 * @param {string} variant - Card variant: 'default', 'blog', 'testimonial', 'certificate', 'process', 'about'
 * @param {string} className - Additional CSS classes
 * @param {number} columns - Number of columns in desktop view (default: 3)
 */
function BentoGrid({
  items,
  variant = "default",
  className = "",
  columns = 3,
}) {
  // Generate the grid columns class based on the columns prop
  const getGridColumnsClass = () => {
    switch (columns) {
      case 1:
        return "md:grid-cols-1";
      case 2:
        return "md:grid-cols-2";
      case 3:
        return "md:grid-cols-3";
      case 4:
        return "md:grid-cols-4";
      case 5:
        return "md:grid-cols-5";
      case 6:
        return "md:grid-cols-6";
      default:
        return "md:grid-cols-3";
    }
  };

  // Generate the column span class based on the item's colSpan
  const getColSpanClass = (span) => {
    switch (span) {
      case 2:
        return "md:col-span-2";
      case 3:
        return "md:col-span-3";
      case 4:
        return "md:col-span-4";
      case 5:
        return "md:col-span-5";
      case 6:
        return "md:col-span-6";
      default:
        return "";
    }
  };

  return (
    <div
      className={cn(
        "grid grid-cols-1",
        getGridColumnsClass(),
        "gap-4",
        className
      )}
    >
      {items.map((item, index) => {
        // Calculate the proper colSpan - ensuring it doesn't exceed total columns
        const span = Math.min(item.colSpan || 1, columns);
        const colSpanClass = span > 1 ? getColSpanClass(span) : "";

        return (
          <AnimatedGroup key={index} className={colSpanClass}>
            <Card item={item} index={index} variant={variant} />
          </AnimatedGroup>
        );
      })}
    </div>
  );
}

export { BentoGrid };
